module.exports = __webpack_public_path__ + "img/67.4d9da274.jpeg";